import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_INTERVENTIONS = "SET_INTERVENTIONS";
export const SET_FILTERED_AND_SORTED_INTERVENTIONS = "SET_FILTERED_AND_SORTED_INTERVENTIONS";

export const SET_DISPLAY_INTERVENTIONS_WITHOUT_CERFA = "SET_DISPLAY_INTERVENTIONS_WITHOUT_CERFA";
export const SET_DISPLAY_ENDED_INTERVENTIONS = "SET_DISPLAY_ENDED_INTERVENTIONS";
export const SET_SELECTED_TYPE = "SET_INTERVENTION_SELECTED_TYPE";
export const SET_SELECTED_STATE = "SET_INTERVENTION_SELECTED_STATE";
export const SET_END_DATE = "SET_INTERVENTION_END_DATE";
export const SET_START_DATE = "SET_INTERVENTION_START_DATE";
export const SET_DISPLAY_AS_LIST = "SET_DISPLAY_AS_LIST";

export const SET_CURRENT_INTERVENTION = "SET_CURRENT_INTERVENTION";
export const SET_ATTACHMENTS = "SET_ATTACHMENTS";

export const NB_MAX_PLANNED_INTERVENTION_TO_DISPLAY = 3;
